import * as React from 'react';
import styled from 'styled-components';
import LocationSearchInput from './LocationSearchInput';

const AddressInputFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 4px;
  height: 64px;
`;

interface props {
  style?: React.CSSProperties;
  onChange?: ((value: string) => void);
  address?: string;
}

class AddressInputForm extends React.Component<props, any> {
  render() {
    return (
      <AddressInputFormContainer style={this.props.style}>
        <LocationSearchInput
          InputTitleText="Address"
          InputPlaceholderText="Your Address (e.g. Harnwell)"
          onChange={this.props.onChange}
          address={this.props.address}
        />
      </AddressInputFormContainer>
    );
  }
}

export default AddressInputForm;



// WEBPACK FOOTER //
// ./src/components/FormComponents/AddressInputForm.tsx